module.exports = __webpack_public_path__ + "static/media/pilates.26f237a2.jpg";